import { KatButton, KatInput } from '@amzn/katal-react';
import React, { memo, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useURLSiteParam } from 'src/core/hooks/UseURLSiteParam';
import { getGranularSLAPath } from 'src/utils/Routes';

import '../../styles/granularSLA/gslaLandingPage.css'

const GranularSLALandingPage = memo(() =>
{

    const navigate = useNavigate();
    let siteId = useURLSiteParam();


    const handleSiteSelection = useCallback(() => {


        const gslaPath = getGranularSLAPath( siteId!='' ? siteId : 'OAK4' );

        console.log( gslaPath)
        navigate(gslaPath);
    },[]);


    const handleAllChanges = useCallback((event: any) => {
        siteId = event.target.value;
    },[]);
    return (
        <div>
            <h3>Please select the site you wish to view or edit Granular SLA values for:</h3>
            <div className="site-selection-container">
                <KatInput
                    type='text'
                    value='OAK4'
                    id='siteSelectInput'
                    onChange={handleAllChanges}
                />
                <KatButton onClick={handleSiteSelection}>Select site</KatButton>
            </div>
        </div>
    );
});

export default GranularSLALandingPage;